export default "__VITE_ASSET__CSd7s_ih__"